module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-MediumItalic.b7fbea7.woff";